var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex_center contractStatusScheduled",class:("contractStatus_scheduled_" + _vm.status)},[_vm._v(" "+_vm._s(_vm.$t(_vm.scheduledKey))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }